import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { ApiEndpoints } from './api-endpoints';
import { VendorListResponse } from '../models/vendor.model';

@Injectable({ providedIn: 'root' })
export class VendorService {
  private baseUrl = environment.fileUpload;

  constructor(private http: HttpClient) {}

  getVendors(jwt: string, pageNumber: number = 1, pageSize: number = 10, identifier: string = '',flag:string=''): Observable<VendorListResponse> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'version': '1.0',
      'jwt': jwt,
      'authtype': 'jwt'
    });
    let url = `${environment.baseUrl}${ApiEndpoints.VENDOR_LIST}?pageNumber=${pageNumber}&pageSize=${pageSize}`;
    if (identifier) {
      url += `&identifier=${identifier}`;
    }
    if (flag) {
      url += `&flag=${flag}`;
    }
    return this.http.get<VendorListResponse>(
      url,
      { headers }
    );
  }

  onboardVendor(data: any, jwt: string): Observable<any> {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Content-Type': 'application/json',
      'version': '1.0',
      'jwt': jwt,
      'authtype': 'jwt'
    });
    return this.http.post(
      `${environment.baseUrl}${ApiEndpoints.VENDOR_ONBOARD}`,
      data,
      { headers }
    );
  }

  getDashboardCounts(jwt: string): Observable<any> {
    const headers = new HttpHeaders({
      'accept': 'application/json',
      'jwt': jwt,
      'authtype': 'jwt',
      'version': '1.0'
    });
    return this.http.get(`${environment.baseUrl}${ApiEndpoints.VENDOR_DASHBOARD_COUNT}`, { headers });
  }

  deleteVendor(vendorId: string, jwt: string) {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'version': '1.0',
      'jwt': jwt,
      'authtype': 'jwt'
    });
    return this.http.delete(
      `${environment.baseUrl}${ApiEndpoints.VENDOR_DELETE}/${vendorId}`,
      { headers }
    );
  }

  getVendorById(vendorId: string, jwt: string) {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'version': '1.0',
      'authtype': 'jwt',
      'jwt': jwt
    });
    return this.http.get(
      `${environment.baseUrl}${ApiEndpoints.VENDOR_GET_BY_ID}?vendorId=${vendorId}`,
      { headers }
    );
  }

  updateVendor(vendorId: string, data: any, jwt: string) {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Content-Type': 'application/json',
      'authtype': 'jwt',
      'jwt': jwt
    });
    return this.http.put(
      `${environment.baseUrl}${ApiEndpoints.VENDOR_UPDATE}/${vendorId}`,
      data,
      { headers }
    );
  }

  updateVendorStatus(vendorId: string, isActive: boolean, jwt: string) {
    const headers = new HttpHeaders({
      'accept': '*/*',
      'Content-Type': 'application/json',
      'authtype': 'jwt',
      'jwt': jwt,
      'version': '1.0'
    });
    return this.http.post(
      `${environment.baseUrl}${ApiEndpoints.VENDOR_CHANGE_STATUS}`,
      { vendorId, isActive },
      { headers }
    );
  }
}
